const LEGEND_CONFIG = {
  horizontalAlign: 'center',
};

export default class LegendConfigBuilder {
  #config = { ...LEGEND_CONFIG };

  build() {
    return this.#config;
  }
}
